import React, { useEffect, useState } from 'react';
import logo from './logo.svg';
import './App.css';
import StoryCard from './components/StoryCard';
import data from './assets/data.json'
import { Container, Row, Col, Button, Form, InputGroup } from 'react-bootstrap';
import { SearchHeart } from 'react-bootstrap-icons';
import { supabase_stories } from './utils/supabase';
import CardsPage from './pages/CardsPage';
import useAuthStore from './stores/useAuthStore';
import { LoginPage } from './pages/LoginPage';
import useNavigationStore, { NavigationPage } from './stores/useNavigationStore';
import AppNavBar from './components/Navbar';


// const test = ['story1', 'story2']

type Data = {
  title: string;
  imageURL: string;
  MP3File: string;
}[]

type Stories = {
  id: number;
  created_at: string;
  title: string;
  imageURL: string;
  MP3File: string;
}

function App() {
  const cleanedData = data as Data
  // const [stories, setStories] = useState<Stories[]>([])

  const user = useAuthStore((state) => state.user)
  const session = useAuthStore((state) => state.session)
  const checkSession = useAuthStore((state) => state.checkSession)
  const logout = useAuthStore((state) => state.logout)


  const navigationStore = useNavigationStore((state) => state)




  useEffect(() => {
    checkSession()

  }, [user]);

  // async function getStories() {
  //   const { data, error } = await supabase_stories.from('Stories').select()
  //   if (error) {
  //     console.error(error)
  //     return
  //   }
  //   setStories(data)
  // }

  // useEffect(() => {
  //   getStories();
  //   console.log(supabase_stories)

  // }, []);


  useEffect(() => {
    if (navigationStore.page === 'login') {
      checkSession()
      if (user != null) {
        navigationStore.setPage(NavigationPage.Cards)
      }
    } else {
      if (user == null) {
        navigationStore.setPage(NavigationPage.Login)
      }

    }

  }, [navigationStore.page, user]);

  const RenderPage: React.FC = () => {

    switch (navigationStore.page) {
      case 'cards':
        return (

          <Container fluid className='ff_repunzel ' >
            <Row className="justify-content-md-center my-3">
              <AppNavBar />
            </Row>

            <Row className="justify-content-md-center my-3">
              <CardsPage />

            </Row>
          </Container>


        )
        break;
      default:
        return <LoginPage />
        break;
    }
    // if (user != null) {
    //   return <CardsPage />
    // } else {
    // }
  }



  return (<>

    <RenderPage />
    {/* 
    <Container fluid className='ff_repunzel' >
      <Row className="">


        <Col xs='12'>
         <RenderPage/>
        </Col>
      </Row>

    </Container> */}

  </>);
  // Old code:
  return (<>
    <div className="App">
      <h1>Bedtime Stories</h1>

      <div className={'container'}>
        {/* Container for Flex */}
        {cleanedData.map((element, index) => (<>
          <StoryCard title={element.title} imageURL={element.imageURL} MP3File={element.MP3File} />
        </>))


        }
      </div>
      <div className={'grid-container'}>
        {/* Container for Flex */}
        {cleanedData.map((element, index) => (<>
          <StoryCard title={element.title} imageURL={element.imageURL} MP3File={element.MP3File} />
        </>))

        }
      </div>



      {/* <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <p>
          Edit <code>src/App.tsx</code> and save to reload.
        </p>
        <a
          className="App-link"
          href="https://reactjs.org"
          target="_blank"
          rel="noopener noreferrer"
        >
          Learn React
        </a>
      </header> */}
    </div>


  </>);
}

export default App;
